// extracted by mini-css-extract-plugin
export default {"productDescription":"m_-z","featuredDescription":"n_-z","description":"o_-z","more":"p_-z","descriptionSku":"q_-z"};